import React from 'react'
import { NavLink } from 'react-router-dom'
import style from './help.style'
import cx from 'classnames'

// COMPONENTS
import LogoHelpData from '../../components/app-logo/logo-help'
import { BackIcon } from '../../components/app-icon/Icons'

const Sidenav = ({ classes }) => {
  const url = document.referrer

  return (
    <aside className={classes.sidenav}>
      <div className="sidenav__header">
        <LogoHelpData />
        <a href={url} className="sidenav__linkBack">
          назад
          <span
            style={{
              transform: 'rotate(-180deg)',
              marginLeft: 10,
              width: 24,
              height: 24,
            }}
          >
            <BackIcon width={24} height={24} stroke={'#000000'} />
          </span>
        </a>
      </div>

      <nav className={classes.sidenav__menu}>
        <Accordion cls={classes} />
      </nav>
    </aside>
  )
}

class Accordion extends React.Component {
  render() {
    const data = [
      {
        title: 'Настройка Google Analytics (GA)',
        links: [
          {
            title: 'Как создать представление',
            url: '',
          },
          {
            title: 'Как создать набор данных',
            url: 'nabor-dannyh-dlya-podklyucheniya-ds',
          },
          {
            title: 'Как включить электронную торговлю',
            url: 'kak-vklyuchit-elektronnuyu-torgovlyu-ga',
          },
          {
            title: 'Почему возникает ошибка в GA',
            url: 'authorize_errors',
          },
          {
            title: 'Получение Google Client ID',
            url: 'poluchenie-clientid',
          },
        ],
      },
      {
        title: 'Подключение CRM систем',
        links: [
          {
            title: 'amoCRM',
            url: 'podklyuchenie-amocrm',
          },
          {
            title: 'Битрикс24',
            url: 'podklyuchenie-bitrix24',
          },
          {
            title: 'retailCRM',
            url: 'podklyuchenie-retail-crm',
          },
          {
            title: 'envyCRM',
            url: 'podklyuchenie-envy-crm',
          },
          {
            title: 'U-ON.Travel',
            url: 'podklyuchenie-uon-travel-crm',
          },
          {
            title: 'Мегаплан',
            url: 'podklyuchenie-megaplan',
          },
          {
            title: 'YClients',
            url: 'podklyuchenie-yclients',
          },
          {
            title: 'Своя CRM',
            url: 'podklyuchenie-kastomnyh-crm',
          },
        ],
      },
      {
        title: 'Подключение коллтрекинга',
        links: [
          {
            title: 'CoMagic',
            url: 'podklyuchenie-comagic',
          },
          {
            title: 'CallTrackingBy',
            url: 'podklyuchenie-calltracking',
          },
        ],
      },
      {
        title: 'UTM-метки',
        links: [
          {
            title: 'Разметка utm-меток',
            url: 'razmetka-utm-metok',
          },
          {
            title: 'Почему utm-метки необходимы для передачи расходов',
            url: 'utm',
          },
          {
            title: 'Рекомендации по разметке Google Ads',
            url: 'rekomendacii-po-razmetke-kampanij-google-ads',
          },
          {
            title: 'Рекомендации по разметке Яндекс Директ',
            url: 'yandex-direct-utm',
          },
        ],
      },
      {
        title: 'Отчеты в GA',
        links: [
          {
            title: 'Основные стандартные отчеты',
            url: 'osnovnye-standartnye-otchety-ga',
          },
          {
            title: 'Создание кастомных отчетов',
            url: 'sozdanie-kastomnyh-otchetov-ga',
          },
          {
            title: '5 полезных кастомный отчетов',
            url: '5-poleznyh-kastomnyh-otchetov-v-google-analytics',
          },
        ],
      },
    ]

    const { cls } = this.props

    return (
      <div className={cls.wrapper}>
        <ul className={cls.accordionList}>
          {data.map((data, key) => {
            return (
              <li key={key} className={cx(cls.accordionListItem)}>
                <AccordionItem {...data} cls={cls} />
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

class AccordionItem extends React.Component {
  state = {
    opened: true,
  }

  render() {
    const {
      props: { title, links, cls },
      state: { opened },
    } = this

    return (
      <div
        className={cx(cls.accordionItem, { [cls.accordionItemOpened]: opened })}
      >
        <div
          className={cx(cls.accordionItemLine)}
          onClick={() => {
            this.setState({ opened: !opened })
          }}
        >
          <h3 className={cx(cls.accordionItemTitle)}>{title}</h3>
          <span className={cx(cls.accordionItemIcon)} />
        </div>

        {links.map(({ title, url }, index) => (
          <div key={`${index}wqtey`} className={cx(cls.accordionItemInner)}>
            <div className={cx(cls.accordionItemContent)}>
              <NavLink
                to={`/help/${url}`}
                className={cls.sidenav__link}
                activeClassName={cls.sidenav__link_active}
                exact
              >
                {title}
              </NavLink>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default style(Sidenav)
